var MetadataBase = /** @class */ (function () {
    function MetadataBase() {
    }
    MetadataBase.prototype.loadFromSchema = function (schema) {
        this.title = schema.title;
        this.description = schema.description;
        this.ordinal = schema["x-ordinal"];
        this.hidden = schema["x-hidden"];
    };
    return MetadataBase;
}());
export { MetadataBase };
